<template>
  <div class="guide-wrapper">
    <div class="guide-card">
      <div class="card-body">
        <!-- 左栏：Logo -->
        <div class="card-left">
          <img :src="ossPath + 'logo.gif'" class="logo-img" alt="幻之大地">
        </div>

        <!-- 右栏：导航菜单 -->
        <div class="card-right">
          <div class="nav-section">
            <h3 class="nav-title">快速入口</h3>
            <div class="nav-links">
              <router-link :to="{name:'login'}" class="nav-item">返回登录</router-link>
              <router-link :to="{name:'register'}" class="nav-item">居民入住</router-link>
              <router-link :to="{name:'about'}" class="nav-item">关于幻地</router-link>
              <router-link :to="{name:'version'}" class="nav-item">版本说明</router-link>
            </div>
          </div>
          <div class="nav-section">
            <h3 class="nav-title">旅游指南</h3>
            <div class="nav-links">
              <router-link :to="{name:'property'}" class="nav-item guide-item">用户属性</router-link>
              <router-link :to="{name:'operation'}" class="nav-item guide-item">基本操作</router-link>
              <router-link :to="{name:'worldmap'}" class="nav-item guide-item">世界地图</router-link>
              <router-link :to="{name:'chatMovement'}" class="nav-item guide-item">聊天动作图鉴</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="page-footer">
      <div class="copyright">
        ©Copyright 2019 <a href="http://www.huanzhidadi.com" target="_blank">幻之大地</a> ALL RIGHTS RESERVED. <a href="https://beian.miit.gov.cn" target="_blank" title="豫ICP备17045248号-3">豫ICP备17045248号-3</a>
      </div>
      <div class="advice">
        抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。<br/>适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。
      </div>
    </div>
  </div>
</template>
<script>
  import {postRequest} from '../utils/api'
  import {putRequest} from '../utils/api'
  import {getRequest} from '../utils/api'
  import Message from 'element-ui/lib/message'
  export default{
    data(){
      return {
      }
    },
    methods: {
      
    },
    mounted: function() {
      
    },
  }
</script>
<style scoped>

/* ========== 页面容器 ========== */
.guide-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f0f2f5;
  padding: 40px 16px;
  box-sizing: border-box;
}

/* ========== 卡片 ========== */
.guide-card {
  width: 100%;
  max-width: 720px;
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08), 0 1px 4px rgba(0, 0, 0, 0.04);
  padding: 36px 40px;
  box-sizing: border-box;
}

/* ========== 左右栏 ========== */
.card-body {
  display: flex;
  align-items: center;
}

.card-left {
  flex: 0 0 42%;
  text-align: center;
  padding-right: 32px;
}

.card-right {
  flex: 1;
  min-width: 0;
}

/* ========== Logo ========== */
.logo-img {
  max-width: 100%;
  height: auto;
  display: inline-block;
}

/* ========== 导航 ========== */
.nav-section {
  margin-bottom: 24px;
}

.nav-section:last-child {
  margin-bottom: 0;
}

.nav-title {
  margin: 0 0 12px;
  font-size: 16px;
  color: #303133;
  padding-left: 8px;
  border-left: 3px solid #409eff;
}

.nav-links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.nav-item {
  display: inline-block;
  padding: 6px 14px;
  font-size: 14px;
  color: #606266;
  text-decoration: none;
  background: #f5f7fa;
  border-radius: 6px;
  transition: all 0.2s;
  white-space: nowrap;
}

.nav-item:hover {
  color: #409eff;
  background: #ecf5ff;
}

.guide-item {
  background: #f0f9eb;
  color: #67c23a;
}

.guide-item:hover {
  background: #e1f3d8;
  color: #529b2e;
}

/* ========== Footer ========== */
.page-footer {
  text-align: center;
  margin-top: 28px;
  padding: 0 16px;
}

.page-footer .copyright {
  font-size: 12px;
  color: #999;
  line-height: 1.6;
}

.page-footer .copyright a {
  color: #909399;
  text-decoration: none;
  transition: color 0.2s;
}

.page-footer .copyright a:hover {
  color: #409eff;
}

.page-footer .advice {
  font-size: 11px;
  color: #aaa;
  line-height: 1.7;
  margin-top: 6px;
}

/* ========== 移动端适配 ========== */
@media (max-width: 768px) {
  .guide-wrapper {
    padding: 16px 10px;
    justify-content: flex-start;
    padding-top: 20px;
  }

  .guide-card {
    max-width: 360px;
    width: 92%;
    padding: 20px 16px;
    border-radius: 12px;
  }

  .card-body {
    flex-direction: column;
  }

  .card-left {
    flex: 0 0 auto;
    width: 100%;
    text-align: center;
    padding-right: 0;
    margin-bottom: 12px;
  }

  .logo-img {
    max-width: 100px;
  }

  .nav-section {
    margin-bottom: 18px;
  }

  .nav-title {
    font-size: 15px;
    margin-bottom: 10px;
  }

  .nav-item {
    font-size: 13px;
    padding: 5px 12px;
  }

  .page-footer {
    margin-top: 16px;
  }

  .page-footer .copyright {
    font-size: 10px;
  }

  .page-footer .advice {
    font-size: 10px;
  }
}
</style>
